export const defaultCustomProps = {
  basePath: '/funding-platform/elegibilidade',
};

export type AppCustomProps = typeof defaultCustomProps;
